import { render, staticRenderFns } from "./JectSelectSsp.vue?vue&type=template&id=70a5057a&"
import script from "./JectSelectSsp.vue?vue&type=script&lang=js&"
export * from "./JectSelectSsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports